import { useState } from "react";
import { QrReader } from "react-qr-reader";

export default function QRCodeScanner() {
  const [data, setData] = useState("No result");

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <h1 className="text-xl font-bold mb-4">QR Code Scanner</h1>
      <div className="w-full max-w-md border rounded-lg overflow-hidden">
        <QrReader
          onResult={(result, error) => {
            if (result) {
              setData(result.text);
            }
            if (error) {
              console.error(error);
            }
          }}
          constraints={{ facingMode: "environment" }}
          style={{ width: "100%" }}
        />
      </div>
      <p className="mt-4 text-lg font-medium">Scanned Data: {data}</p>
    </div>
  );
}
